import React from 'react';
import styled from 'styled-components';
import Button from './Button';
export var PrimaryButtonIconTypes;
(function (PrimaryButtonIconTypes) {
    PrimaryButtonIconTypes["ADD"] = "ADD";
    PrimaryButtonIconTypes["NONE"] = "NONE";
    PrimaryButtonIconTypes["SAVE"] = "SAVE";
    PrimaryButtonIconTypes["DELETE"] = "DELETE";
})(PrimaryButtonIconTypes || (PrimaryButtonIconTypes = {}));
const IconAdd = require('../assets/images/glyphs/add_pri.svg');
const IconSave = require('../assets/images/glyphs/save_pri.svg');
const IconDelete = require('../assets/images/glyphs/delete_pri.svg');
const PrimaryButton = ({ imgSrc, iconType = PrimaryButtonIconTypes.NONE, ...rest }) => {
    if (typeof (imgSrc) === 'undefined') {
        if (iconType === PrimaryButtonIconTypes.ADD) {
            imgSrc = IconAdd;
        }
        else if (iconType === PrimaryButtonIconTypes.SAVE) {
            imgSrc = IconSave;
        }
        else if (iconType === PrimaryButtonIconTypes.DELETE) {
            imgSrc = IconDelete;
        }
    }
    return React.createElement(StyledButton, { imgSrc: imgSrc, ...rest });
};
const StyledButton = styled(Button) `

    padding: 9px 15px 9px ${props => props.isLoading ? 11 : 15}px;

    border-radius: 4px;
    background: ${props => props.theme.colors.green};
    
    color: ${props => props.theme.colors.white};
    
    :hover {
        background: ${props => props.theme.colors.greenLighter};
    }
    
    :active {
        background: ${props => props.theme.colors.green};
    }
    
    img {
    
        height: 20px;
        width: ${props => props.isLoading ? 20 : 13}px;
        
        margin-right: ${props => props.isLoading ? 7 : 10}px;
    }
`;
export default PrimaryButton;
//# sourceMappingURL=PrimaryButton.js.map